import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
	// Always initialize to false to match SSR and prevent hydration mismatch
	// The actual value is determined after mount in useEffect
	const [isMobile, setIsMobile] = useState<boolean>(false);

	useEffect(() => {
		// Set the initial value on mount
		const checkMobile = () => window.innerWidth < MOBILE_BREAKPOINT;
		setIsMobile(checkMobile());

		// Listen for resize changes
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
		const onChange = () => {
			setIsMobile(checkMobile());
		};
		mql.addEventListener('change', onChange);
		return () => mql.removeEventListener('change', onChange);
	}, []);

	return isMobile;
}
